export { IndependentSidesIcon } from './IndependentSidesIcon';
